export default __webpack_public_path__ + "static/coindreams-280155b0b8451e6b20f7809b62fe6424.jpg";